<div class="header">Site {{site?.name}}</div>

<div class="tree-details-container">


  <div class="tree">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-nested-tree-node *matTreeNodeDef="let node">
        <div class="mat-tree-node">
          <button mat-icon-button disabled></button>
          <mat-icon class="tree-icon">
            @if (node.type=='site') {
            factory
            }
            @else if (node.type=='offering-tree') {
            folder
            }
            @else if (node.type=='asset') {
            settings
            }
            factory
          </mat-icon>
          <span (click)="onNodeSelect(node)" [class.selected-location]="node === selectedNode">
            {{node.name}}
          </span>
        </div>
      </mat-nested-tree-node>

      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle (click)="onNodeSelect(node)">
            <mat-icon class="tree-icon">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-icon class="tree-icon">
            @if (node.type=='site') {
            factory
            }
            @else if (node.type=='offering-tree') {
            folder
            }
            @else if (node.type=='asset') {
            settings
            }
            factory
          </mat-icon>
          <span (click)="onNodeSelect(node)" [class.selected-location]="node === selectedNode">{{node.name}}</span>
        </div>
        <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>

  <div class="assets-panel">
    <ul class="assets-list" *ngIf="selectedNode?.hasAssets">
      <li *ngFor="let asset of selectedNode?.assets" (click)="onAssetSelect(asset)"
        [ngClass]="{'selected-asset': asset === selectedAsset}">
        <mat-icon class="asset-list-icon">settings</mat-icon>&nbsp;{{asset.name}}
      </li>
    </ul>
  </div>

  <div class="details-panel">
    <div class="details-header">
      @if (selectedAsset!=null && selectedAsset.underlyingAsset?.assetId!=null) {
      <mat-icon class="header-icon">settings</mat-icon>&nbsp;Asset:&nbsp;<a
        href='/asset/{{selectedAsset.underlyingAsset?.assetId}}'>{{selectedAsset.underlyingAsset?.assetId}}</a>
      }
      @else if (selectedNode?.type=='site')
      {
      <mat-icon class="header-icon">factory</mat-icon>&nbsp;{{'Site: ' + selectedNode?.underlyingSite?.name}}
      }
      @else if (selectedNode?.type=='offering-tree') {
      <mat-icon class="header-icon">folder</mat-icon>&nbsp;{{'Offering tree: ' +
      selectedNode?.underlyingOfferingTree?.Description + ' (' + selectedNode?.underlyingOfferingTree?.cid + ')'}}
      }
      @else {
      Select element
      }
    </div>
    <div class="details-contents">

      <site-details *ngIf="selectedAsset==null && selectedNode?.type=='site'"
        [site]="selectedNode?.underlyingSite"></site-details>
      <asset-detail *ngIf="selectedAsset!=null" [asset]="selectedAsset.underlyingAsset"></asset-detail>

    </div>
  </div>
</div>